import React, { useState } from "react";
import Key from "../../util/Key";
import { useForm } from "react-hook-form";
import Input from "../inputs/Input";
import Select from "../inputs/Select";
import TextArea from "../inputs/TextArea";

const PreviewEdit = ({ dataInput, setEditableInput, setItemEditable }) => {
    const {
        register,
        formState: { errors },
    } = useForm();

    return (
        <div className="d-flex justify-content-center ">
            <div className="col-12">
                {dataInput.length > 0 && (
                    <form className="border-none rounded-3">
                        <div className="row mb-3 mt-3 d-flex justify-content-center">
                            <div className="col-12 text-center">
                                <h1>Vista Previa</h1>
                            </div>
                            {dataInput.map((item) => {
                                switch (item.input.type) {
                                    case "input":
                                        return (
                                            <div
                                                className={
                                                    item.size == "0"
                                                        ? "col-sm-6 col-12 mb-3"
                                                        : "col-12 mb-3"
                                                }
                                                key={Key()}
                                                onClick={() => {
                                                    setEditableInput(true);
                                                    setItemEditable(item);
                                                }}
                                            >
                                                <Input
                                                    input={item}
                                                    register={register}
                                                    errors={errors}
                                                />
                                            </div>
                                        );
                                    case "text_area":
                                        return (
                                            <div
                                                className={
                                                    item.size == "0"
                                                        ? "col-sm-6 col-12 mb-3"
                                                        : "col-12 mb-3"
                                                }
                                                key={Key()}
                                                onClick={() => {
                                                    setEditableInput(true);
                                                    setItemEditable(item);
                                                }}
                                            >
                                                <TextArea
                                                    key={Key()}
                                                    input={item}
                                                    register={register}
                                                    errors={errors}
                                                />
                                            </div>
                                        );
                                    case "select":
                                        return (
                                            <div
                                                className={
                                                    item.size == "0"
                                                        ? "col-sm-6 col-12 mb-3"
                                                        : "col-12 mb-3"
                                                }
                                                key={Key()}
                                                onClick={() => {
                                                    setEditableInput(true);
                                                    setItemEditable(item);
                                                }}
                                            >
                                                <Select
                                                    key={Key()}
                                                    input={item}
                                                    register={register}
                                                    errors={errors}
                                                />
                                            </div>
                                        );
                                    default:
                                        return <h1>nada</h1>;
                                }
                            })}
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
};

export default PreviewEdit;
